(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-model/assets/javascripts/utils/prolongation.js') >= 0) return;  svs.modules.push('/components/numbergames/game-model/assets/javascripts/utils/prolongation.js'); 
'use strict';

function numbersAreEqual(prolongedNumbers, numbers) {
  if (!prolongedNumbers && !numbers) {
    return true;
  }
  if (!Array.isArray(prolongedNumbers) || !Array.isArray(numbers)) {
    return false;
  }
  if (prolongedNumbers.length !== numbers.length) {
    return false;
  }
  for (let i = 0, len = numbers.length; i < len; i++) {
    if (prolongedNumbers[i].number !== numbers[i].number) {
      return false;
    }
  }
  return true;
}
function boardsAreEqual(prolongedBoards, boards) {
  if (!Array.isArray(prolongedBoards) || !Array.isArray(boards)) {
    return false;
  }
  if (prolongedBoards.length !== boards.length) {
    return false;
  }
  for (let i = 0, len = boards.length; i < len; i++) {
    const prolongedBoard = prolongedBoards[i];
    const board = boards[i];
    if (Boolean(prolongedBoard.hasKungKeno) !== Boolean(board.hasKungKeno)) {
      return false;
    }
    if (prolongedBoard.level !== board.level) {
      return false;
    }
    if (!numbersAreEqual(prolongedBoard.numbers, board.numbers)) {
      return false;
    }
    if (!numbersAreEqual(prolongedBoard.numbersExtra, board.numbersExtra)) {
      return false;
    }
  }
  return true;
}

function isProlongedBet(bet) {
  if (!bet || !bet.prolongedBet) {
    return false;
  }
  const prolongedBet = bet.prolongedBet;
  if (prolongedBet.itsId !== bet.itsId) {
    return false;
  }

  if (prolongedBet.rowPriceMulti !== bet.rowPriceMulti) {
    return false;
  }
  return boardsAreEqual(prolongedBet.boards, bet.boards);
}

function isProlongedJoker(jokerBet) {
  if (!jokerBet || !jokerBet.prolongedBet) {
    return false;
  }
  const prolongedJoker = jokerBet.prolongedBet;
  if (prolongedJoker.jokerItsId !== jokerBet.jokerItsId) {
    return false;
  }
  if (prolongedJoker.jokerPrice !== jokerBet.jokerPrice) {
    return false;
  }
  return numbersAreEqual(prolongedJoker.jokerRow, jokerBet.jokerRow);
}
svs.numbergames.game_model.utils.prolongation = {
  isProlongedBet,
  isProlongedJoker
};
 })(window);